export default "__VITE_ASSET__Dzcqftuy__"